import { render, staticRenderFns } from "./SdkDocumentSearch.vue?vue&type=template&id=f9bdedac"
import script from "./SdkDocumentSearch.vue?vue&type=script&lang=js"
export * from "./SdkDocumentSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports